import { render } from "./CartaCurso.vue?vue&type=template&id=263431d7&scoped=true"
import script from "./CartaCurso.vue?vue&type=script&lang=js"
export * from "./CartaCurso.vue?vue&type=script&lang=js"

import "./CartaCurso.vue?vue&type=style&index=0&id=263431d7&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263431d7"]])

export default __exports__